import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";

/**
 * @description 茅台二期
 * @return {/culturalExchange_maotaisecond/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)
  // const [shiwuThing, setShiwuThing] = useState({})
  const { nftNo } = qs.parse(window.location.search);
  const [detailData, setDetailData] = useState({})
  const [show,setShow] = useState(false)//兑换弹窗
  const [exchangeCode,setExchangeCode] = useState("")//输入的兑换码
  const [showTip, setShowTip] = useState(false)//提示框显示状态
  const [recData, setRecData] = useState({})//兑换信息

  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
      // getData2()
    })()

  }, []);
//   const getData2 = async () => {
//     try {
//         showLoading()
//         const res = await Service.getGoodsDetail({collectionId: Service.collectionId})
//         hideLoading();
//         if (res.code !== '000000') throw res.msg;
//         if (res.data && res.data.info) {
//             setDetailData(res.data.info)
//         }
//     } catch (error) {
//         Toast.show(error);
//     }
  
// }
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    // const res2 = await Service.getGoodsData({},nftNo);
    try {
      if (loading) showLoading();
      if (loading) {
        const userInfoRes = await Service.getUserCertificateStatus();
        const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        setHasPermission(accessRes.data?.isPermission)
        // console.log(accessRes.data, accessRes.data.isPermission);
        // const res2 = await Service.getGoodsData({},nftNo);
        // if(res2?.data?.length > 0){
        //   const shiwu = res2.data.find(item => item?.goodsType === 3)
        //   console.log('shiwu===>', shiwu)
        //   setShiwuThing(shiwu)
        // }
        const resdata = await Service.getRecData();
        if (resdata.code !== '000000') throw resdata.msg;
        setRecData(resdata.data);
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data);
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  const buyHandle = () => {
    if(!hasPermission){
      return;
    }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${Service.collectionId}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
    
  }
  const gotoSalePay = () => {
    const params = {
      collectionId:detailData.collectionId,
      saleBatchId:detailData.saleBatchInfo?.saleBatchId || '',
      code: Service.activityCode,
    }
    
    if (window.JsBridge.hasWebViewBridge()) {
        window.JsBridge.push("Web", { uri: `${window.location.origin}/ape/PayPage?${qs.stringify(params)}` });
    } else {
      navigate(`/ape/PayPage?${qs.stringify(params)}`);
    }
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }
  const toRecord = () => {
    const uri = `/culturalExchange_maotaisecond/collectionRecord`
    if(uri){
      navigate(uri);
    }
  }
  const toExchange = () => {
    const uri = `/culturalExchange_maotaisecond/exchangepage`
    if(uri){
      navigate(uri);
    }
    // if (window.JsBridge.hasWebViewBridge()) {
    //   window.JsBridge.push("CustomWeb", {
    //     uri: `${window.location.origin}${uri}`,
    //   });
    // } else {
    //   navigate(uri);
    // }
  }
  const exChange = () => {
    setShow(true);
  }
  const toggleTip = () => {
    setShowTip(!showTip);
  }
  const inputChange = (e) =>{
    setExchangeCode(e.target.value);
  }
  const comfirmExChange = async () =>{
    if(!exchangeCode){
      Toast.show("请输入兑换码")
      return
    }
    const res = await Service.checkRedeemCode(exchangeCode);
    if (res.status === 1){
      setShow(false);
      const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const param = objectToQueryParams({
        idf: 'exchangeCultural_seasons',
        activityCode: Service.activityCode,
        req: data?.defaultGoods?.id,
        name: data?.defaultGoods?.goodsName,
        imgUrl: data?.defaultGoods?.imgUrl,
        productId:data?.defaultGoods?.goodsId,
        isChangeName:0,
        clientId: userInfo?.clientId,
        skUId: data?.defaultGoods?.goodsId,
        prizeImgUrl: data?.defaultGoods?.imgUrl,
        prizeName: data?.defaultGoods?.goodsName,
        nftNo: nftNo,
        needShowCount:1,
        remark:exchangeCode,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
    }
    onDidFocus();
  }
  //立即领取 ，跳转G-member订单页面
  const handleToOrder = async (type) => {
    //type 1 去领取 2 查看详情
    if(type === 1 && !data?.badgeFlag) {
      // Toast.show('请先持有欧皇徽章')
      return
    }
    if(type === 1){
      const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const param = objectToQueryParams({
        idf: 'exchangeCultural_gold',
        activityCode: Service.activityCode,
        req: data?.noPlatformGoods?.id,
        name: data?.noPlatformGoods?.goodsName,
        imgUrl: data?.noPlatformGoods?.imgUrl,
        productId:data?.noPlatformGoods?.goodsId,
        isChangeName:0,
        clientId: userInfo?.clientId,
        skUId: data?.noPlatformGoods?.goodsId,
        prizeImgUrl: data?.noPlatformGoods?.imgUrl,
        prizeName: data?.noPlatformGoods?.goodsName,
        nftNo: nftNo,
        remark: 1,
        needShowCount:data?.badgeNum||0,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
    }else{
      const param = objectToQueryParams({
        id: data?.badgeRecord?.id,
        phone: data?.badgeRecord?.phone,
        prizeImgUrl: data?.badgeRecord?.productImgUrl,
        prizeName: data?.badgeRecord?.productName,
        prizeType: data?.badgeRecord?.productType,
        skuId: data?.noPlatformGoods?.goodsId,
        createTime: data?.badgeRecord?.createTime,
        consigneeName: data?.badgeRecord?.consigneeName,
        consigneeNumber: data?.badgeRecord?.consigneeNumber,
        province: data?.badgeRecord?.province,
        city: data?.badgeRecord?.city,
        area: data?.badgeRecord?.area,
        street: data?.badgeRecord?.street,
        address: data?.badgeRecord?.address,
        deliverStatus:data?.badgeRecord?.deliverGoods||0,
        deliverGoods:data?.badgeRecord?.deliverGoods||0,
        logCo:data?.badgeRecord?.logCo||"",
        trackNo:data?.badgeRecord?.trackNo||"",
        shipDate:data?.badgeRecord?.shipDate||"",
        orderId:data?.badgeRecord?.orderId||"",
        needShowCount:data?.badgeRecord?.desc||0,
      });
      window.JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_GKT_LINK}/front/activities/lottery/orderDetail?${param}`});
    }
    onDidFocus();
  }
  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.hintBtnBox}>
          <div className={Styles.hintBtn1} style={{ filter: data?.priFlag ? '' : 'grayscale(1)'}} >
            {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
          </div>
          <div className={Styles.hintBtn2} style={{ filter: data?.publicFlag ? '' : 'grayscale(1)'}}>
          {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
        </div>
      </div>
      <div className={Styles.buyBtn} style={{ filter: hasPermission ? '' : 'grayscale(1)'}} onClick={buyHandle} disabled={!hasPermission}>
        {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
      </div>
      {/* <button className={Styles.myCollectionsBtn} onClick={toMyGuards}>我的藏品{">"}</button> */}
      {data?.priFlag && <div className={Styles.textCount}>优先购最多可购买{data?.priNum || 0}个</div>}
      {/* <div className={Styles.textCount}>优先购最多可购买{data?.priNum || 0}个</div> */}

      <div className={Styles.centerCard}>
        <div className={Styles.centerCardBox1}>
            <div className={Styles.context}>
              <div className={Styles.lefttem}>
                  <div className={Styles.leftItem1}>
                    欧皇徽章权益领取
                  </div>
              </div>
              <div className={Styles.rightItem}>
                  {!data?.hasBadgeFlag && <div className={Styles.leftItem2} style={{ filter: data?.badgeFlag ? '' : 'grayscale(1)'}} onClick={()=>handleToOrder(1)}></div>}
                  {data?.hasBadgeFlag &&<div className={Styles.leftItem3} onClick={()=>handleToOrder(2)}>查看详情{'>'}</div>}
              </div>
            </div>
        </div>

        <div className={Styles.centerCardBox3}>
          <div className={Styles.title}>兑换“春”数字资产</div>
          <div className={Styles.context}>
          <div className={Styles.rareItemsCard2 + ' ' + Styles.htn359h}>
              <div className={Styles.htntitle1}>
                <div>可兑换个数</div>
                <div className={Styles.imageWrapper} onClick={toggleTip}>
                   <img src={require('@/assets/img/culturalExchange_maotaisecond/htn1@2x.png')} alt="提示" />
                </div>
                <div>：{recData?.collRedeemNum || 0}</div>
                {showTip && (
                  <div className={Styles.tipBox}>
                    <div>一比一兑换个数: {recData?.oneToOne || 0}</div>
                    <div>二比一兑换个数: {recData?.twoToOne || 0}</div>
                  </div>
                )}
              </div>
              <div className={Styles.htncontent1}>
                <div className={Styles.imageWrapper}>
                   <img src={require('@/assets/img/culturalExchange_maotaisecond/springcollection@2x.png')} alt="春藏品" />
                </div>
                <div className={Styles.htncontent1text}>特殊持仓用户：每持有 1 套全套漫画/1 个欧皇徽章，可获得一比一兑换次数一次<br />
                普通用户：二比一兑换一个</div>
              </div>
                <div className={Styles.exchangeBtn} onClick={toExchange}>
                  <button>立即兑换</button>
                </div>
            </div>
          </div>

          <div className={Styles.title + ' ' + Styles.htn48t}>四季福利藏品收集</div>
          <div className={Styles.context}>
          <div className={Styles.rareItemsCard2}>
             <div className={Styles.htntitle1}>
                全套四季无聊猿福利！
              </div>
              <div className={Styles.htncontent1}>
                <div className={Styles.imageWrapper}>
                   <img src={require('@/assets/img/culturalExchange_maotaisecond/PFP@2x.png')} alt="提示" />
                </div>
                <div className={Styles.htncontent1text2}>
                  <div className={Styles.htncontent1text2text1}>每持有一套绿地四季无聊猿，可空投1 个四季无聊猿PFP</div>
                  <div className={Styles.htncontent1text2text2}>2025.11.21  15:00验仓</div>
                </div>
              </div>

              <div className={Styles.htntitle1 + ' ' + Styles.htn51t}>
              巽风 x 绿地共创福利！
              </div>
              <div className={Styles.htncontent1}>
                <div className={Styles.imageWrapper}>
                   <img src={require('@/assets/img/culturalExchange_maotaisecond/digitalbadge@2x.png')} alt="提示" />
                </div>
                <div className={Styles.htncontent1text2}>
                  <div className={Styles.htncontent1text2text1}>每持有绿地和巽风同一季节藏品，可空投获得该季节数字徽章一枚</div>
                  <div className={Styles.htncontent1text2text2}>验仓时间以公告为准</div>
                </div>
              </div>

            </div>
          </div>



          
          <div className={Styles.title + ' ' + Styles.htn48t}>藏品权益</div>
          <div className={Styles.context}>
          <div className={Styles.rareItemsCard}>
              <div className={Styles.title1}>

              </div>
              <div className={Styles.itemsContainer}>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_seasons/coupon@2x.png')} alt="优惠券" />
                    </div>
                    <div className={Styles.itemText}>优惠券</div>
                  </div>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_seasons/wine@2x.png')} alt="胡椒树葡萄酒" />
                    </div>
                    <div className={Styles.itemText}>胡椒树葡萄酒</div>
                  </div>
                </div>
                <div className={Styles.exchangeBtn} onClick={exChange}>
                  {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
                </div>
                <div className={Styles.centerCardBox4} onClick={toRecord}>
                    兑换记录{">"}
                </div>
            </div>
            <div className={Styles.rareItemsCard}>
              <div className={Styles.title2}>
                
              </div>
              <div className={Styles.itemsContainer}>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_seasons/cup@2x.png')} alt="巽风七曜水晶杯" />
                    </div>
                    <div className={Styles.itemText}>巽风七曜水晶杯</div>
                  </div>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_seasons/goods2@2x.png')} alt="数字藏品" />
                    </div>
                    <div className={Styles.itemText}>贵州茅台酒•四季系列产品行权资格</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={Styles.footerBox}>
            <div className={Styles.footer}></div>
          </div>
      </div>


          {
                show?<div className={Styles.modal}>
                    <div className={Styles.modelShadow} onClick={()=>setShow(false)}></div>
                    <div className={Styles.content1}>
                        <div className={Styles.title}>权益兑换</div>
                        <div className={Styles.hintbox}>
                          <span>您可领取： </span>
                          <br/>
                          <span>1. 满500减150*1张、满200减50*1张、满100减</span>
                          <br/>
                          <span>20*1张，可用于G优商城消费抵扣</span>
                          <br/>
                          <span>2. 胡椒树葡萄酒一瓶</span>
                        </div>
                        <div className={Styles.inputTitle}>请输入巽风平台提供的兑换码</div>
                        <input className={Styles.input} placeholder="请输入兑换码" onChange={inputChange} inputMode="text" autoComplete="off" autoCorrect="off" autoCapitalize="off"></input>
                        <div className={Styles.hintTitle}>温馨提示：每个兑换码仅能兑换一次哦</div>
                        <div className={Styles.confirmBtn} >
                          <button className={Styles.confirmBtnTitle} onClick={comfirmExChange}>确认兑换</button>
                        </div>
                    </div>
                </div>:null
              }
    </div>
  )
}
export default Home
